import { createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../config'
import { getIDToken } from '../utils/AuthUtil'
import {
  setCurrentSubscriptionPlan,
  setSubscriptions,
  setSubscriptionsLoadingInProgress,
} from '../actions/payment'

export const fetchSubscriptionsAsync = createAsyncThunk(
  'subscription/fetchSubscriptions',
  async (_, { dispatch }) => {
    return fetch(`${BASE_URL}/api/payment/subscriptions`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(setSubscriptions(data))
        dispatch(setSubscriptionsLoadingInProgress(false))
      })
      .catch((error) =>
        console.error('Error during fetching subscriptions: ', error),
      )
  },
)

export const fetchOrganizationSubscriptionAsync = createAsyncThunk(
  'subscription/fetchOrganizationSubscription',
  async ({ organization_id }: any, { dispatch }) => {
    return fetch(`${BASE_URL}/api/payment/fetchOrganizationSubscription`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ organization_id }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.statusCode === 500) {
          const message = JSON.parse(data.body)
          dispatch(setCurrentSubscriptionPlan(message))
        } else dispatch(setCurrentSubscriptionPlan(data))
      })
      .catch((error) =>
        console.error('Error during fetching subscriptions: ', error),
      )
  },
)
